import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function ReadingProgress() {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const [readingTime, setReadingTime] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollY / docHeight) * 100 : 0;
      setProgress(Math.min(100, Math.max(0, pct)));
      setVisible(scrollY > 120);
    };

    // Estimate reading time based on page text content
    const estimateReadingTime = () => {
      const text = document.body.innerText || '';
      const wordCount = text.trim().split(/\s+/).length;
      const minutes = Math.max(1, Math.round(wordCount / 200));
      setReadingTime(minutes);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    estimateReadingTime();
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          className="fixed top-0 left-0 right-0 z-[60]"
        >
          {/* Progress bar */}
          <div className="w-full h-1 bg-gray-100/80 backdrop-blur-sm">
            <motion.div
              className="h-full bg-primary-500"
              style={{ width: `${progress}%` }}
              transition={{ duration: 0.1, ease: 'linear' }}
            />
          </div>

          {/* Reading time + percentage label */}
          <div className="flex items-center justify-between px-4 md:px-8 py-1.5 backdrop-blur-sm">
            {/* <span className="text-[11px] md:text-xs text-gray-500 font-medium tracking-wide uppercase">
              Reading time: {readingTime} min
            </span>
            <span className="text-[11px] md:text-xs text-primary-600 font-semibold tabular-nums">
              {Math.round(progress)}%
            </span> */}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}